const STATUT_CONFIG = {
    A_VALIDER: { bg: "#fbf3d9", color: "#9a6a12", dot: "#c8a44d", rail: "#c8a44d" },
    VALIDE:    { bg: "#e7f8f0", color: "#08784a", dot: "#17b978", rail: "#17b978" },
};

const DEFAULT_STATUT_CONFIG = { color: "#5a6d68", dot: "#5a6d68", rail: "#d8d2c6" };

const AVATAR_PALETTE = [
    { bg: "#dbeafe", color: "#1d4ed8" },
    { bg: "#dcfce7", color: "#15803d" },
    { bg: "#fef3c7", color: "#b45309" },
    { bg: "#ede9fe", color: "#7c3aed" },
    { bg: "#fce7f3", color: "#be185d" },
    { bg: "#e0f2fe", color: "#0369a1" },
];

const avatarCache = {};
let avatarCounter = 0;

export function statusConfigOf(statut) {
    return STATUT_CONFIG[statut] || DEFAULT_STATUT_CONFIG;
}

export function getAvatarColor(key) {
    if (!avatarCache[key]) {
        avatarCache[key] = AVATAR_PALETTE[avatarCounter % AVATAR_PALETTE.length];
        avatarCounter++;
    }
    return avatarCache[key];
}

export function getReadableTextColor(background) {
    const hex = background.replace("#", "");
    const red = Number.parseInt(hex.slice(0, 2), 16);
    const green = Number.parseInt(hex.slice(2, 4), 16);
    const blue = Number.parseInt(hex.slice(4, 6), 16);
    return (red * 299 + green * 587 + blue * 114) / 1000 >= 150
        ? "#1e293b"
        : "#ffffff";
}

export function getEhpadAvatarColor(ehpadName, assignedColor) {
    if (/^#[0-9A-Fa-f]{6}$/.test(assignedColor || "")) {
        return { bg: assignedColor, color: getReadableTextColor(assignedColor) };
    }
    return getAvatarColor(ehpadName);
}

export function commandeSender(cmd) {
    const supplierName = cmd.medicalEquipmentSupplier?.name;
    if (supplierName) return { name: supplierName, colors: getAvatarColor(supplierName) };
    const ehpadCode = cmd.ehpadCode
        || cmd.ehpad?.code
        || (cmd.ehpadNom && cmd.ehpadNom !== "AUTRE" ? cmd.ehpadNom : "—");
    return { name: ehpadCode, colors: getEhpadAvatarColor(ehpadCode, cmd.ehpadColor) };
}

export function commandeRowColors({ isRead, isFocused, isSelected, isLocked, isValide, statusRail }) {
    let background = "white";
    if (isRead) background = "#e7eae7";
    if (isValide) background = "#f4fff9";
    if (isLocked) background = "#fffbeb";
    if (isFocused) background = "#edf5f2";
    if (isSelected) background = "#dfeeea";

    let hover = "#eef7f3";
    if (isRead) hover = "#dde2de";
    if (isValide) hover = "#e7f8f0";
    if (isLocked) hover = "#fef3c7";

    let rail = statusRail;
    if (isRead) rail = "#a9b8b2";
    if (isValide) rail = "#17b978";

    let boxShadow = "none";
    if (isFocused) boxShadow = "inset 0 0 0 2px rgba(23, 185, 120, 0.35)";
    if (isSelected) boxShadow = "inset 0 0 0 2px #0c3b3c";
    return { background, hover, rail, boxShadow };
}

const DESTINATIONS = {
    ROBOT: { key: "robot", label: "Robot" },
    ETIQUETAGE: { key: "etiquetage", label: "Étiquetage" },
};

export function productDestination(product) {
    return DESTINATIONS[product.destination] ?? { key: "autre", label: "Non assigné" };
}
